import * as actualiteStyles from '../../../styles/widgets/actualite.module.scss';
import * as styleLink from '../../../styles/communs/polylink.module.scss';
import PropTypes from 'prop-types';

import {GatsbyImage, getImage} from 'gatsby-plugin-image';
import {altNN, getDate, getDisplayLang} from '../../../utils/parsing';

import PolyLink from '../PolyLink';
import React from 'react';
import clsx from 'clsx';
import { getObjectUrl } from '../../../utils/utils';

const Actualite = ({
  elem,
  locale,
  siteURL,
  row,
  column
}) => {
  let
    event,
    start_date,
    url,
    heading,
    evt_language,
    cover,
    target,
    title = null;
  if (!elem)
    return;
  if (elem.__typename === 'CmsPortalComponentWidgetEvent'){
    event = elem.event;
    if(!event)
      return;
    start_date = event.start_date;
    url = getObjectUrl(siteURL, event.slug, 'event', locale);
    ({heading, evt_language, cover, title} = event || {});
  } else if (elem.__typename === 'CmsPortalComponentWidgetNewsItem'){
    event = elem.news;
    if(!event)
      return;
    start_date = event?.publishedAt;
    url = getObjectUrl(siteURL, event?.slug, 'news_item', locale);
    ({heading, evt_language, cover, title} = event || {});
  } else if (elem.__typename === 'CmsPortalComponentWidgetFocus'){
    heading = elem.content;
    cover = elem.media;
    start_date = elem.date;
    target = (elem.new_window) ? '_blank' : '';
    title = elem.title;
    url = elem.link;
  }
  if (!target)
    target = '';
  const nbrLineMid = Math.floor(row / 2);
  const displayLang = getDisplayLang(evt_language, locale);
  const parsedDate = getDate(start_date, '.');
  return (
    <PolyLink
      ariaLabel={title}
      className={clsx(actualiteStyles.bloc, actualiteStyles.hover)}
      dataCy={'actualite-link'}
      tabIndex="0"
      target={target}
      url={url}
    >
      <div
        className={actualiteStyles.blocImage}
        style={{
          gridRow: row % 2 ? `1 / ${Math.ceil(row / 2)}` : `1 / ${Math.ceil(row / 2) + 1}`,
          paddingBottom: `calc((100% / ${column}) * ${nbrLineMid})`,
          gridColumn: row === 1 ? `1 / ${Math.ceil(row / 2) + 1}` : '1 / -1'
        }}
      >
        {cover
          && (
            <GatsbyImage
              alt={altNN('')}
              className={actualiteStyles.image}
              image={getImage(cover.imageFile)}
            />
          )}
      </div>
      <div
        style={{
          gridRow: row % 2 ? `${Math.ceil(row / 2)} / -1` : `${Math.ceil(row / 2) + 1} / -1`,
          paddingBottom: `calc((100% / ${column}) * ${nbrLineMid})`,
          gridColumn: row === 1 ? `${Math.ceil(row / 2) + 1} / -1` : '1 / -1'
        }}
      />
      <div
        className={actualiteStyles.innerBloc}
        style={{
          gridRow: row % 2 ? `${Math.ceil(row / 2)} / -1` : `${Math.ceil(row / 2) + 1} / -1`,
          gridColumn: row === 1 ? `${Math.ceil(row / 2) + 1} / -1` : '1 / -1'
        }}
      >
        <div
          className={actualiteStyles.contentActualite}
        >
          {parsedDate && (
            <div className={actualiteStyles.containerDate}>
              <div className={actualiteStyles.dateBloc}>
                <p
                  className={clsx(actualiteStyles.dateLabel, styleLink.withoutIcon)}
                >
                  {parsedDate}
                </p>
              </div>
            </div>
          )}
          <div className={actualiteStyles.margin}>
            <p
              className={clsx(actualiteStyles.h3Title,
                actualiteStyles.hovered,
                actualiteStyles.title
              )}
              lang={displayLang}
            >
              {title}
            </p>
            <p
              className={clsx(actualiteStyles.nbLines, actualiteStyles.subTitle)}
              lang={displayLang}
              style={{height: 'fit-content'}}
            >
              {heading}
            </p>
          </div>
        </div>
      </div>
    </PolyLink>);
};


Actualite.propTypes = {
  column: PropTypes.number,
  elem: PropTypes.shape({
    __typename: PropTypes.string,
    event: PropTypes.shape({
      heading: PropTypes.string,
      evt_language: PropTypes.string,
      cover: PropTypes.shape({
        imageFile: PropTypes.object,
      }),
      Campus: PropTypes.string,
      locale: PropTypes.string,
      start_date: PropTypes.string,
      target: PropTypes.string,
      title: PropTypes.string,
      slug: PropTypes.string,
    }),
    news: PropTypes.shape({
      publishedAt: PropTypes.string,
    }),
    content: PropTypes.string,
    media: PropTypes.object,
    date: PropTypes.string,
    new_window: PropTypes.bool,
    title: PropTypes.string,
    link: PropTypes.string,
  }),
  locale: PropTypes.string,
  row: PropTypes.number,
  siteURL: PropTypes.string,
};

export default Actualite;
